import { defineStore } from 'pinia';
import { useAPI } from '~/composables/useAPI';

export const useDescargasStore = defineStore('descargas', {
    state: () => ({

    }),
    actions: {
        async sendDescarga(payload) {
            const api = useAPI();
            const response = await api.post('leads', payload);
            //this.destacados = response.data;
        },

    },
});
